import { useEffect, useRef } from 'react';
import constants from '../../config/constants';
import _ from '../../utils/LodashImports';

const useRecommendedProductsHook = ({ title, slots, products, tenant }) => {
  const viewedProducts = useRef(new Set());
  const dispatchDigitalData = (eventName, payload) => {
    const event = new CustomEvent(eventName, {
      bubbles: true,
      detail: { payload },
    });
    window.dispatchEvent(event);
  };

  const onRender = () => {
    const position = slots.split('-')[2] || 0;
    const totalProducts = products.length;
    const displayData = `${title}|${position}|${totalProducts}`;
    dispatchDigitalData('onCarouselLoadEvent', displayData);
  };

  const onProductClick = (indexPod) => {
    const product = products[indexPod];
    const productId = _.get(product, 'productId', '');
    const country = tenant === constants.TENANT_TYPES.SODIMAC_CL ? 'SOCL' : 'SOPE';
    const position = slots.split('-')[2] || 0;
    const productClickData = `CR_RecommendationCarousel!XLP!${country}!x!x!${title}!xlp!${productId}!${indexPod}!${products.length}!${position}`;
    dispatchDigitalData('onProductClickEvent', productClickData);
  };

  const onProductImpression = (indexPod) => {
    const product = products[indexPod];
    const productId = _.get(product, 'productId', '');
    viewedProducts.current.add(productId);
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (products.length && title) {
        const displayData = `${title}-${Array.from(viewedProducts.current).join(',')}`;
        dispatchDigitalData('onCarouselImpressionEvent', displayData);
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [products, title]);

  return {
    onRender,
    onProductClick,
    onProductImpression,
  };
};

export { useRecommendedProductsHook };
